import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as _ from "lodash";
import {CurrencyPipe} from "@angular/common";
import {TaskType} from "../../../tasks/types/task.type";

@Pipe({
  standalone: false,
  name: 'taskCourierPrice'
})
export class TaskCourierPricePipe implements PipeTransform {

  constructor(@Inject(CurrencyPipe) private currencyPipe: CurrencyPipe, @Inject('splitService') private splitService) {
  }

  transform(task, defaultValue?): string {
    if (_.isUndefined(task)) {
      return defaultValue || '';
    }

    const price = task.taskType === TaskType.BundledStopover ? _.sumBy(task.bundledTaskList, (bt: any) => {
      return _.get(bt, 'serviceInfo.courierPrice', 0);
    }) : _.get(task, 'serviceInfo.courierPrice', 0);

    const currency = this.splitService.getCurrencyCode();

    return this.currencyPipe.transform(price, currency);
  }
}
